import { createFileRoute } from '@tanstack/react-router'
import ConfirmEmailPage from '@/spa/pages/ConfirmEmailPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/confirm-email')({
  component: ConfirmEmailPage,
  errorComponent: routeErrorComponent,
})
